'use client'

import { useState } from 'react'

import { Icon, IconComponent } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { useLayoutMobileMenuNavigationContext } from '@common/components/Layout/context/LayoutMobileMenuNavigationContext'
import { AppVariant } from '@common/enums'

import { BaseMobileMenu } from '../../BaseMobileMenu'
import { AddNewDrawer } from '../../components'
import type { MobileMenuShellProps } from '../../mobileMenuShell.types'

import styles from '../../MobileMenu.module.scss'

type PortalMobileMenuProps = MobileMenuShellProps & {
  addNewLabel?: string
  hideAddNew?: boolean
}

export function PortalMobileMenu({
  isOpen,
  onClose,
  menuGroups,
  helpItems,
  addNewLabel = 'Add new',
  hideAddNew = false,
}: PortalMobileMenuProps) {
  const { handleAddProjectClick, handleAddServiceClick, handleAddWorkspaceClick } =
    useLayoutMobileMenuNavigationContext()
  const [isAddNewDrawerOpen, setIsAddNewDrawerOpen] = useState(false)

  const handleAddNewClick = () => setIsAddNewDrawerOpen(true)

  const handleAddNewDrawerClose = () => setIsAddNewDrawerOpen(false)

  const handleAddService = () => {
    handleAddServiceClick()
    onClose()
  }

  const handleAddProject = () => {
    handleAddProjectClick()
    onClose()
  }

  const handleAddWorkspace = () => {
    handleAddWorkspaceClick()
    onClose()
  }

  const navigationTopSlot = hideAddNew ? null : (
    <button className={styles.addNewButton} onClick={handleAddNewClick}>
      <IconComponent icon={Icon.AddFilled} size={24} />
      <span>{addNewLabel}</span>
    </button>
  )

  return (
    <div data-testid={MOBILE_MENU_TEST_IDS.portalMenu} style={{ display: 'contents' }}>
      <>
        <BaseMobileMenu
          isOpen={isOpen}
          onClose={onClose}
          appVariant={AppVariant.PORTAL}
          menuGroups={menuGroups}
          helpItems={helpItems}
          navigationTopSlot={navigationTopSlot}
        />

        <AddNewDrawer
          isOpen={isAddNewDrawerOpen}
          onClose={handleAddNewDrawerClose}
          onAddServiceClick={handleAddService}
          onAddProjectClick={handleAddProject}
          onAddWorkspaceClick={handleAddWorkspace}
        />
      </>
    </div>
  )
}
